import React from 'react'
import PropTypes from 'prop-types'

import PlaceHolder from '../../share/PlaceHolder'
import WidgetType from '../../../enums/WidgetType'
import {
  AudienceTimelineWidget,
  SocialWebTimelineWidget,
  YouTubeTimelineWidget
} from '../Timeline/TimelineWidgets'
import {
  SocialWebTimelineComparisonWidget,
  AudienceTimelineComparisonWidget
} from '../Timeline/TimelineComparisonWidgets'
import SocialWebWordCloudWidget from '../WordCloudWidgets/SocialWebWordCloud'
import SocialWebSentimentDriversWidget from '../WordCloudWidgets/SocialWebSentimentDrivers'
import SocialWebPhotoConceptWidget from '../WordCloudWidgets/SocialWebPhotoConcept'
import AudienceWordCloudWidget from '../WordCloudWidgets/AudienceWordCloud'
import AudienceSentimentDriversWidget from '../WordCloudWidgets/AudienceSentimentDrivers'
import SocialWebDayAndHour from '../DayAndHourWidgets/SocialWebDayAndHour'
import AudienceDayAndHour from '../DayAndHourWidgets/AudienceDayAndHour'
import SocialWebDomainsWidget from '../SocialWebDomains'
import SocialWebSourcesWidget from '../SocialWebSources'
import MetricGride from '../MetricGrid'
import HeaderWidget from '../Header'
import SocialWebSentimentWidget from '../SentimentWidgets/SocialWebSentiment'
import AudienceSentimentWidget from '../SentimentWidgets/AudienceSentiment'
import ImageWidget from '../Image'
import TextWidget from '../Text'
import RichTextWidget from '../RichText'
import SocialWebGeoRegionsWidget from '../GeoRegionsWidgets/SocialWebGeoRegions'
import AudienceGeoRegionsWidget from '../GeoRegionsWidgets/AudienceGeoRegions'
import SocialWebStoryScopeWidget from '../SocialWebStoryScope'
import {
  AudienceTopicComparisonWidget,
  SocialWebTopicComparisonWidget
} from '../TopicComparisonWidgets'
import CustomVisualizationWidget from '../CustomVisualization'
import { AudienceAuthorsWidget, SocialWebAuthorsWidget } from '../AuthorsWidgets'
import SocialWebCrosstabWidget from '../CrosstabWidgets/SocialWebCrosstab'
import AudienceCrosstabWidget from '../CrosstabWidgets/AudienceCrosstab'
import SocialWebDemographicWidget from '../DemographicWidgets/SocialWebDemographic'
import AudienceDemographicWidget from '../DemographicWidgets/AudienceDemographic'
import SocialWebSideBySideWidget from '../SideBySideWidgets/SocialWebSideBySide'
import SocialWebSummaryMetricsCompactWidget from '../SummaryMetricsCompactWidgets/SocialWebSummaryMetricsCompact'
import AudienceSummaryMetricsCompactWidget from '../SummaryMetricsCompactWidgets/AudienceSummaryMetricsCompact'
import SocialWebTrendingWidget from '../TrendingWidgets/SocialWebTrending'
import AudienceTrendingWidget from '../TrendingWidgets/AudienceTrending'
import AudienceStream from '../StreamWidgets/AudienceStream'
import SocialWebStream from '../StreamWidgets/SocialWebStream'
import SocialWebSummaryMetricsWidget from '../SummaryMetricsWidgets/SocialWebSummaryMetrics'
import AudienceSummaryMetricsWidget from '../SummaryMetricsWidgets/AudienceSummaryMetrics'
import SocialWebPopularPostsWidget from '../SocialWebPopularPosts'
import SocialWebPopularMediaWidget from '../PopularMediaWidgets/SocialWebPopularMedia'
import AudiencePopularMediaWidget from '../PopularMediaWidgets/AudiencePopularMedia'
import SocialWebBrandPassionIndexWidget from '../SocialWebBrandPassionIndex'
import SocialWebIndexWidget from '../IndexWidgets/SocialWebIndex'
import AudienceIndexWidget from '../IndexWidgets/AudienceIndex'
import SocialWePopularLinksWidget from '../PopularLinksWidgets/SocialWebPopularLinks'
import AudiencePopularLinksWidget from '../PopularLinksWidgets/AudienceWebPopularLinks'
import SocialWebChannelsWidget from '../SocialWebChannels'
import HTMLWidget from '../HTML'
import { SocialWebTagsWidget } from '../TagsWidgets'
import { SocialWebLanguageWidget, AudienceLanguageWidget } from '../LanguageWidgets'
import AudienceUsageAndAttitudeWidget from '../AudienceUsageAndAttitude'

export const WIDGET_MAP = {
  [WidgetType.SOCIAL_WEB_WORDCLOUD]: (widgetId) => <SocialWebWordCloudWidget widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_SENTIMENT_DRIVERS]: (widgetId) => (
    <SocialWebSentimentDriversWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_PHOTO_CONCEPTS]: (widgetId) => (
    <SocialWebPhotoConceptWidget widgetId={widgetId} />
  ),
  [WidgetType.AUDIENCE_WORDCLOUD]: (widgetId) => <AudienceWordCloudWidget widgetId={widgetId} />,
  [WidgetType.AUDIENCE_SENTIMENT_DRIVERS]: (widgetId) => (
    <AudienceSentimentDriversWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_DAY_AND_HOUR]: (widgetId) => <SocialWebDayAndHour widgetId={widgetId} />,
  [WidgetType.AUDIENCE_DAY_AND_HOUR]: (widgetId) => <AudienceDayAndHour widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_TIMELINE]: (widgetId) => <SocialWebTimelineWidget widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_TIMELINE_OLD]: (widgetId) => (
    <SocialWebTimelineWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_TIMELINE_COMPARISON]: (widgetId) => (
    <SocialWebTimelineComparisonWidget widgetId={widgetId} />
  ),
  [WidgetType.AUDIENCE_TIMELINE]: (widgetId) => <AudienceTimelineWidget widgetId={widgetId} />,
  [WidgetType.AUDIENCE_TIMELINE_OLD]: (widgetId) => <AudienceTimelineWidget widgetId={widgetId} />,
  [WidgetType.AUDIENCE_TIMELINE_COMPARISON]: (widgetId) => (
    <AudienceTimelineComparisonWidget widgetId={widgetId} />
  ),
  [WidgetType.YOUTUBE_TIMELINE]: (widgetId) => <YouTubeTimelineWidget widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_DOMAINS]: (widgetId) => <SocialWebDomainsWidget widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_SOURCES]: (widgetId) => <SocialWebSourcesWidget widgetId={widgetId} />,
  [WidgetType.METRIC_GRID]: (widgetId) => <MetricGride widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_SENTIMENT]: (widgetId) => <SocialWebSentimentWidget widgetId={widgetId} />,
  [WidgetType.AUDIENCE_SENTIMENT]: (widgetId) => <AudienceSentimentWidget widgetId={widgetId} />,
  [WidgetType.HEADER]: (widgetId) => <HeaderWidget widgetId={widgetId} />,
  [WidgetType.IMAGE]: (widgetId) => <ImageWidget widgetId={widgetId} />,
  [WidgetType.TEXT]: (widgetId) => <TextWidget widgetId={widgetId} />,
  [WidgetType.WHITESPACE]: () => <></>,
  [WidgetType.RICH_TEXT]: (widgetId) => <RichTextWidget widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_GEO_REGIONS]: (widgetId) => (
    <SocialWebGeoRegionsWidget widgetId={widgetId} />
  ),
  [WidgetType.AUDIENCE_GEO_REGIONS]: (widgetId) => <AudienceGeoRegionsWidget widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_STORY_SCOPE]: (widgetId) => (
    <SocialWebStoryScopeWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_TOPIC_COMPARISON]: (widgetId) => (
    <SocialWebTopicComparisonWidget widgetId={widgetId} />
  ),
  [WidgetType.AUDIENCE_TOPIC_COMPARISON]: (widgetId) => (
    <AudienceTopicComparisonWidget widgetId={widgetId} />
  ),
  [WidgetType.AUDIENCE_AUTHORS]: (widgetId) => <AudienceAuthorsWidget widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_AUTHORS]: (widgetId) => <SocialWebAuthorsWidget widgetId={widgetId} />,
  [WidgetType.CUSTOM_VISUALIZATION]: (widgetId) => (
    <CustomVisualizationWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_CROSSTAB]: (widgetId) => <SocialWebCrosstabWidget widgetId={widgetId} />,
  [WidgetType.AUDIENCE_CROSSTAB]: (widgetId) => <AudienceCrosstabWidget widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_DEMOGRAPHIC]: (widgetId) => (
    <SocialWebDemographicWidget widgetId={widgetId} />
  ),
  [WidgetType.AUDIENCE_DEMOGRAPHIC]: (widgetId) => (
    <AudienceDemographicWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_SIDE_BY_SIDE]: (widgetId) => (
    <SocialWebSideBySideWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_SUMMARY_METRICS_COMPACT]: (widgetId) => (
    <SocialWebSummaryMetricsCompactWidget widgetId={widgetId} />
  ),
  [WidgetType.AUDIENCE_SUMMARY_METRICS_COMPACT]: (widgetId) => (
    <AudienceSummaryMetricsCompactWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_TRENDING]: (widgetId) => <SocialWebTrendingWidget widgetId={widgetId} />,
  [WidgetType.AUDIENCE_TRENDING]: (widgetId) => <AudienceTrendingWidget widgetId={widgetId} />,
  [WidgetType.AUDIENCE_STREAM]: (widgetId) => <AudienceStream widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_STREAM]: (widgetId) => <SocialWebStream widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_SUMMARY_METRICS]: (widgetId) => (
    <SocialWebSummaryMetricsWidget widgetId={widgetId} />
  ),
  [WidgetType.AUDIENCE_SUMMARY_METRICS]: (widgetId) => (
    <AudienceSummaryMetricsWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_POPULAR_POSTS]: (widgetId) => (
    <SocialWebPopularPostsWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_POPULAR_MEDIA]: (widgetId) => (
    <SocialWebPopularMediaWidget widgetId={widgetId} />
  ),
  [WidgetType.AUDIENCE_POPULAR_MEDIA]: (widgetId) => (
    <AudiencePopularMediaWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_BRAND_PASSION_INDEX]: (widgetId) => (
    <SocialWebBrandPassionIndexWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_INDEX]: (widgetId) => <SocialWebIndexWidget widgetId={widgetId} />,
  [WidgetType.AUDIENCE_INDEX]: (widgetId) => <AudienceIndexWidget widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_POPULAR_LINKS]: (widgetId) => (
    <SocialWePopularLinksWidget widgetId={widgetId} />
  ),
  [WidgetType.AUDIENCE_POPULAR_LINKS]: (widgetId) => (
    <AudiencePopularLinksWidget widgetId={widgetId} />
  ),
  [WidgetType.SOCIAL_WEB_CHANNELS]: (widgetId) => <SocialWebChannelsWidget widgetId={widgetId} />,
  [WidgetType.HTML]: (widgetId) => <HTMLWidget widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_TAGS]: (widgetId) => <SocialWebTagsWidget widgetId={widgetId} />,
  [WidgetType.SOCIAL_WEB_LANGUAGE]: (widgetId) => <SocialWebLanguageWidget widgetId={widgetId} />,
  [WidgetType.AUDIENCE_LANGUAGE]: (widgetId) => <AudienceLanguageWidget widgetId={widgetId} />,
  [WidgetType.AUDIENCE_USAGE_AND_ATTITUDE]: (widgetId) => (
    <AudienceUsageAndAttitudeWidget widgetId={widgetId} />
  )
}

const WidgetFactory = ({ type, widgetId }) => {
  return WIDGET_MAP[type]?.(widgetId) ?? <PlaceHolder />
}

WidgetFactory.propTypes = {
  type: PropTypes.string.isRequired,
  widgetId: PropTypes.number.isRequired
}

export default WidgetFactory
